import EditBookingDetail from "../features/bookings/editbookingDetails/EditBookingDetail";

function EditBookingDetails() {
  return  <EditBookingDetail/>;
}

export default EditBookingDetails;
